import { LinkForm, type LinkFormProps } from '@/components/admin/liens/link-form';
import { VitrineLinkForm } from '@/components/admin/vitrine/vitrine-link-form';
import { useIsVitrine } from '@/lib/use-instance';

/**
 * The form of a link for the server that is asked (docs/specs/vitrine.md
 * section 3.4, issue #192): the atelier's `LinkForm`, or on the vitrine the
 * `VitrineLinkForm` that offers no version.
 *
 * Both take the same props, so the two places that mount a link form - the
 * creation of Réglages > Partage and the « Modifier » of a card - say
 * `<RoleLinkForm>` and are not told which one they hold. A component and not a
 * conditional at each call site: the day a third place mounts the form it
 * cannot forget the vitrine.
 */

export function RoleLinkForm(props: LinkFormProps) {
  const vitrine = useIsVitrine();
  return vitrine ? <VitrineLinkForm {...props} /> : <LinkForm {...props} />;
}
